import Flickity from 'flickity'
import on from 'dom-event'
import debounce from 'lodash/debounce'

export default el => {
  const selectors = {
    slider: '.js-featured-categories-slider',
    slide: '.js-featured-categories-slide'
  }

  const slides = [...el.querySelectorAll(selectors.slide)]
  const sliderElement = el.querySelector(selectors.slider)
  let flktyInstance = null

  const initSlider = () => {
    if (!flktyInstance) {
      flktyInstance = new Flickity(sliderElement, {
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'left',
        freeScroll: false,
        wrapAround: false,
        groupCells: true,
        contain: true
      })
    }
  }

  const destroySlider = () => {
    if (flktyInstance) {
      flktyInstance.destroy()
      flktyInstance = null
    }
  }

  const checkSliderActive = () => {
    const windowWidth = window.innerWidth

    if (
      (windowWidth <= 1023 && slides.length > 1) || (windowWidth >= 1024 && slides.length > 3)) {
      initSlider()
    } else {
      destroySlider()
    }
  }

  checkSliderActive()
  on(window, 'resize', debounce(checkSliderActive, 300))
}
